import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import authReducer from './reducer/authreducer';
import courseReducer from './reducer/coursereducer';
import quizReducer from './reducer/quizreducer';
import errorReducer from './reducer/errorreducer';
import routeReducer from './reducer/routereducer';
import SlashRouteReducer from './reducer/slashRouteReducer';
import logger from 'redux-logger';

const RouteReducer = combineReducers({ authReducer, courseReducer, quizReducer, errorReducer, routeReducer, SlashRouteReducer })

function configureStore() {
    return createStore(RouteReducer, {}, applyMiddleware(thunk));
}

const store = configureStore();
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js